export const normalizeExpiryDate = (value: string) => {
  //should be in the format of MM/YY while the user is typing
  //return a string of length 5 with MM/YY format
  return (
    value
      .replace(/[^0-9]/g, '')
      .match(/\d{1,2}/g)
      ?.join('/')
      .slice(0, 5) || ''
  );
};

export const normalizeNumber = (value: string) => {
  return value.replace(/[^0-9]+/g, '');
};

export const normalizeCVC = (value: string) => {
  //only numbers
  //max 4
  return value.replace(/[^0-9]+/g, '').slice(0, 4) || '';
};

export const normalizeName = (value: string) => {
  //allow only letters, apostrophes, hyphen, dots and spaces
  return value.replace(/[^a-zA-Z\s-.'\.\(\)]+/g, '') || '';
};
